const enquiries = {
  enquiries: {
    title: 'الاستفسارات',
    subtitle: 'إدارة المحادثات مع العملاء المحتملين',
    noThreads: 'لا توجد استفسارات بعد',
    noThreadsDescription: 'عندما يستفسر شخص ما عن عقاراتك، ستظهر المحادثات هنا.',
    searchPlaceholder: 'البحث في المحادثات...',

    threadList: {
      title: 'المحادثات',
      empty: 'لا توجد محادثات',
      unread: '{{count}} غير مقروءة',
      lastMessage: 'آخر رسالة',
    },

    chat: {
      placeholder: 'اكتب رسالتك...',
      send: 'إرسال',
      sending: 'جارٍ الإرسال...',
      messageSent: 'تم إرسال الرسالة',
      messageError: 'فشل إرسال الرسالة',
      loadingMessages: 'جارٍ تحميل الرسائل...',
      noMessages: 'لا توجد رسائل بعد',
      startConversation: 'ابدأ المحادثة',
      you: 'أنت',
      today: 'اليوم',
      yesterday: 'أمس',
    },

    property: {
      viewProperty: 'عرض العقار',
      price: 'السعر',
    },

    notifications: {
      newMessage: 'رسالة جديدة',
      newEnquiry: 'استفسار جديد',
      title: 'الإشعارات',
    },

    accessDenied: {
      title: 'الوصول مرفوض',
      description: 'تحتاج إلى اشتراك نشط للوصول إلى الاستفسارات.',
      subscribeButton: 'عرض خطط الاشتراك',
    },

    loginRequired: {
      title: 'تسجيل الدخول مطلوب',
      description: 'يرجى تسجيل الدخول لعرض استفساراتك.',
      loginButton: 'تسجيل الدخول',
    },
  },
};

export default enquiries;
